import React from "react";

export interface INACellProps {
  row: any;
  column: any;
}

const ResolveData: React.FC<INACellProps> = (props) => {
  const {
    row: {
      original: { data },
    },
    column: { id },
  } = props;
  return <>{data?.[id] ? data?.[id] : "N/A"}</>;
};

export default ResolveData;
